import script from "./add-course.vue?vue&type=script&setup=true&lang=js"
export * from "./add-course.vue?vue&type=script&setup=true&lang=js"

import "./add-course.vue?vue&type=style&index=0&id=18dee4bc&scoped=true&lang=css"
import "./add-course.vue?vue&type=style&index=1&id=18dee4bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18dee4bc"]])

export default __exports__